import styles from './styles.module.css';

export default function MethodsSaTool({ dict }) {
    const {
        methods_sa_tool_1,
        methods_sa_tool_2,
        methods_sa_tool_3
    } = dict.discover;

    return (
        <section className={styles.methods_sa_tool}>
            <p>{methods_sa_tool_1}</p>
            <p>{methods_sa_tool_2}</p>
            <p>{methods_sa_tool_3}</p>
        </section>
    );
}
